/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import Form from 'forms/_.extend';

import RemoveUserAccessForm from './RemoveUserAccessForm/RemoveUserAccessForm';
import RemoveUserAccessSuccess from './RemoveUserAccessSuccess/RemoveUserAccessSuccess';
import RemoveUserAccessError from './RemoveUserAccessError/RemoveUserAccessError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  currentAccountDetails: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class RemoveUserAccess extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore, currentAccountDetails }: TypeProps = this.props;

    const user: Object = this.props.formData;

    const fields: Array<Object> = [
      {
        name: 'selectUser',
        label: t('general:actions.remove_trading_account_from'),
        fields: [
          {
            name: 'users',
            label: t('general:user_plural'),
            rules: 'required|array',
            value: [],
            placeholder: t('general:placeholders.first_last_name'),
          },
        ],
      },
      {
        name: 'removeReason',
        label: t('general:users.reasons.why_remove'),
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_removing'),
            rules: 'required|string',
            value: '',
            options: [
              {
                id: '1',
                label: t('general:reasons.options.change_in_role'),
              },
              {
                id: '2',
                label: t('general:reasons.options.access_no_longer_required'),
              },
              {
                id: '3',
                label: t('general:reasons.options.user_has_left_business'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { reason }: Object = data.values().removeReason;

        const { users }: Object = data.values().selectUser;

        actionDrawerStore.removeUserAccess(currentAccountDetails.id, {
          user_ids: users.join(),
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'removeUserAccess',
      }
    );
  };

  render(): React.Node {
    const { t, actionDrawerStore, currentAccountDetails }: TypeProps = this.props;

    const title: string = t('general:actions.remove_trading_account_from_user');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <RemoveUserAccessError />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <RemoveUserAccessSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <RemoveUserAccessForm account={currentAccountDetails} form={this.createForm()} />
      </div>
    );
  }
}
